import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const resource = "/admin/supplier";
export default {
  getListOfSundrySuppliers(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/sundry_suppliers?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  getListOfApprovedSundrySuppliers(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/sundry_supplier_approved?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getSundrySupplierProfile(id) {
    return Repository.get(`${resource}/sundry_suppliers/${id}`)
  },
  updateSundrySupplierProfile(id, payload) {
    return Repository.put(`${resource}/sundry_suppliers/${id}`, payload)
  },
  createSundrySupplier(payload){
    return Repository.post(`${resource}/sundry_suppliers`, payload)
  },
  sundrySupplierStatusChange(id, status) {
    return Repository.put(`${resource}/sundry_supplier/${id}/${status}`)
  },

  getListOfSundryItems(supplier_id, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/sundry_items?supplier_id=${supplier_id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getListOfSystemSundryItems(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/sundry_item/list?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createSundryItem(payload){
    return Repository.post(`${resource}/sundry_items`, payload)
  },
  updateSundryItem(id, payload){
    return Repository.put(`${resource}/sundry_items/${id}`, payload)
  },
  getSundryItemDetails(id) {
    return Repository.get(`${resource}/sundry_items/${id}`)
  },
  sundryItemStatusChange(id, status) {
    return Repository.put(`${resource}/sundry_item/${id}/${status}`)
  },

  getListOfSundrySupplierDocuments(supplier_id, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/sundry_documents?supplier_id=${supplier_id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createSundrySupplierDocument(payload) {
    return Repository.post(`${resource}/sundry_documents`, payload)
  },
  getSundrySupplierDocument(id) {
    return Repository.get(`${resource}/sundry_documents/${id}`)
  },
  updateSundrySupplierDocument(id, payload) {
    return Repository.put(`${resource}/sundry_documents/${id}`, payload)
  },
  sundryDocumentDelete(id) {
    return Repository.delete(`${resource}/sundry_documents/${id}`)
  },

  getListOfSundryItemOrders(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/sundry_item_orders?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  changeSundryItemOrderStatus(id, status, payload = {}) {
    return Repository.put(`${resource}/sundry_item_order/${id}/${status}`, payload)
  },
  sundryOrderItemStatusChange(id, payload ) {
    return Repository.put(`${resource}/sundry-item-order-item/${id}/status`, payload)
  },
  createSundryOrder(payload) {
    return Repository.post(`${resource}/sundry_item_orders`, payload)
  },
  getSundryOrder(id) {
    return Repository.get(`${resource}/sundry_item_orders/${id}`)
  },
  getSundryOrderPdf(id) {
    return Repository.get(`${resource}/sundry_item_order_item/${id}/purchase_order_pdf`)
  },
  getSundryOrderInvoiceEmailLog(id) {
    return Repository.get(`${resource}/sundry-item-order/${id}/sent-email-logs`)
  },
  sendSundryOrderPdf(id, payload) {
    return Repository.post(`${resource}/sundry-item-order/${id}/send-order-confirmation-pdf`, payload)
  },
  getSundryOrderPdfPublic(secret_code) {
    return Repository.get(`${resource}/sundry-item-order/${secret_code}/so-pdf-data`)
  },
  changeSundryOrderHandleType(id) {
    return Repository.put(`${resource}/sundry_item_order/${id}/item_status_handle`)
  },

  getSundryItemCatalogueList(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/sundry_catalogues?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getListOfSundryItemCart() {
    return Repository.get(`${resource}/sundry_item_carts`)
  },
  addItemToTheCart(payload) {
    return Repository.post(`${resource}/sundry_item_carts`, payload)
  },
  removeItemFromCart(id) {
    return Repository.delete(`${resource}/sundry_item_carts/${id}`)
  },
  updateItemFromCart(id, payload) {
    return Repository.put(`${resource}/sundry_item_carts/${id}`, payload)
  },
  getSundryItemsUseReportDetails(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/sundry_item_use_report?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createSundryOrderItemQcTest(payload) {
    return Repository.post(`${resource}/sundry_order_item_q_c_tests`, payload)
  },
  updateSundryItemQuantity(id, payload) {
    return Repository.put(`${resource}/sundry_item_order_item/${id}`, payload)
  },
  getSundryItemDocuments(id) {
    return Repository.get(`${resource}/sundry_item_order/sundry_item_orders/${id}/documents`)
  },
  createSundryItemOrderDocument(id, payload){
    return Repository.post(`${resource}/sundry_item_order/sundry_item_orders/${id}/documents`,payload)
  },
  updateSundryItemOrder(id, payload){
    return Repository.put(`${resource}/sundry_item_orders/${id}`, payload)
  },
  getSundryItemsLowStockReportDetails(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/report/sundry-low-stock-report?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getSundryItemsSlowStockReportDetails(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/report/sundry-slow-stock-report?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },

};
